import { createFileRoute } from "@tanstack/react-router";
import { SiteFooter, SiteHeader } from "@/components/tools/ToolShell";

export const Route = createFileRoute("/es/privacy-policy")({
  head: () => ({
    meta: [
      { title: "Política de Privacidad — Picamini.online" },
      {
        name: "description",
        content: "Política de privacidad de Picamini.online. Conoce cómo protegemos tus datos y garantizamos el procesamiento 100% local en tu navegador.",
      },
    ],
    links: [
      { rel: "canonical", href: "https://picamini.online/es/politica-de-privacidad" },
      { rel: "alternate", hrefLang: "en", href: "https://picamini.online/privacy-policy" },
      { rel: "alternate", hrefLang: "es", href: "https://picamini.online/es/politica-de-privacidad" },
    ],
  }),
  component: EsPrivacyPolicyPage,
});

function EsPrivacyPolicyPage() {
  return (
    <div className="min-h-screen bg-background flex flex-col font-sans">
      <SiteHeader lang="es" />

      <main className="flex-1 py-12 mx-auto max-w-4xl px-4 sm:px-6 lg:px-8 space-y-6">
        <h1 className="text-3xl font-extrabold text-foreground">Política de Privacidad</h1>
        <p className="text-sm text-muted-foreground">Última actualización: Septiembre 2026</p>

        <div className="surface-card p-6 sm:p-8 rounded-2xl bg-card border space-y-4 text-sm sm:text-base text-muted-foreground leading-relaxed">
          <h2 className="text-xl font-bold text-foreground">1. Compromiso de Privacidad</h2>
          <p>
            En Picamini.online la privacidad de nuestros usuarios es la máxima prioridad. Nuestras herramientas para el aula y procesadores de PDF están diseñados para ejecutarse localmente en tu navegador web mediante tecnologías de cliente como JavaScript y WebAssembly.
          </p>

          <h2 className="text-xl font-bold text-foreground">2. Procesamiento de Datos de Alumnos y Archivos PDF</h2>
          <p>
            Las listas de nombres, imágenes o documentos PDF que utilizas en Picamini.online nunca se transmiten ni se almacenan en servidores externos. Todo el procesamiento ocurre en la memoria de tu dispositivo.
          </p>

          <h2 className="text-xl font-bold text-foreground">3. Almacenamiento Local (LocalStorage)</h2>
          <p>
            Guardamos tus preferencias de uso (como el estado del sonido o tus listas personalizadas) en el almacenamiento local de tu navegador (LocalStorage) para tu comodidad en futuras visitas. Puedes borrar estos datos en cualquier momento limpiando el historial de tu navegador.
          </p>

          <h2 className="text-xl font-bold text-foreground">4. Analítica Web</h2>
          <p>
            Utilizamos servicios de analítica estándar (como Google Analytics) únicamente para contabilizar el tráfico general y mejorar la experiencia de usuario. Estos datos son anónimos y agregados.
          </p>

          <h2 className="text-xl font-bold text-foreground">5. Contacto</h2>
          <p>
            Si tienes cualquier duda sobre nuestra política de privacidad, puedes contactarnos en: <strong>support@picamini.online</strong>.
          </p>
        </div>
      </main>

      <SiteFooter lang="es" />
    </div>
  );
}
